<!-- release-notes.component.html -->
<div class="row">
    <div class="columns small-12 medium-10 medium-offset-1">
      <h2 class="page-heading">Release Notes</h2>
    </div>
</div>
<div class="row release-notes-container">
    <div class="release-card columns small-12 medium-10 medium-offset-1" *ngFor="let release of releases">
        <div class="release-header" (click)="toggleExpand(release)">
            <div class="version-date">
             
              <span class="date">{{release.date}}</span>
            </div>
           
            <div class="expand-icon" [class.expanded]="release.expanded">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
        </div>
        <div class="release-details" [class.expanded]="release.expanded">

            <h2 class="version">Here's what's new in {{release.version}}</h2>
            <div class="release-summary">
                <p>{{release.summary}}</p>
              </div>
          <div class="changes-section" *ngIf="release.features.length > 0">
            <!-- <span class="icon">🚀</span>  -->
            <h3>New Features</h3>
            <ul>
              <li *ngFor="let item of release.features">{{item}}</li>
            </ul>
          </div>
          
          <div class="changes-section" *ngIf="release.improvements.length > 0">
            <!-- <span class="icon">🔧</span> -->
            <h3> Improvements</h3>
            <ul>
              <li *ngFor="let item of release.improvements">{{item}}</li>
            </ul>
          </div>
          
          <div class="changes-section" *ngIf="release.bugfixes.length > 0">
            <!-- <span class="icon">🐛</span> -->
            <h3> Bug Fixes</h3>
            <ul>
              <li *ngFor="let item of release.bugfixes">{{item}}</li>
            </ul>
          </div>
          
          <div class="changes-section" *ngIf="release.breaking.length > 0">
            <h3><span class="icon warning">⚠️</span> Breaking Changes</h3>
            <ul class="breaking">
              <li *ngFor="let item of release.breaking">{{item}}</li>
            </ul>
          </div>
        </div>
   </div>
</div>
